<template>
    <div class="rounded" :class="getBGClass()" v-if="(section.status!=='OMITTED') || showOmitted ">
        <div class="flex items-center mb-0">
            <div class="w-6 flex-shrink-0">
            </div>
            <div class="flex-grow">
                <div
                    class="whitespace-pre-line text-lg m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 resize-none"
                    :class="(((status==='OMITTED') || (proposedStatus==='OMITTED')) ?' text-red-600 line-through':'') + getBGClass()"
                >
                    <div class="line-through font-medium text-gray-400" v-if="operationsFromExists('name')"
                         v-text="operationsFrom('name')"></div>
                    <div :class="operationsFromExists('name')?'font-semibold':''" v-text="name"></div>
                </div>
            </div>
            <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5">
            </div>
        </div>
        <contracted-works-task v-for="task in section.tasks" :key="task.id" :showItemProgress="showItemProgress"
                               :search="search"
                               :readonly="true"
                               :contracted-works="contractedWorks"
                               :show-omitted="showOmitted"
                               :section="section"
                               :latest="latest"
                               :currently-building="currentlyBuilding"
                               :current-viewing="currentViewing"
                               :show-total="false"
                               :latest-progress-report="latestProgressReport"
                               :operations="operations"
                               :task="task" :ref="'tasks'"></contracted-works-task>

    </div>
</template>

<script>
import draggable from 'vuedraggable'
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import {toCurrency, uuid} from "../../../utils";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import ContractedWorksTask from "./ContractedWorksTask.vue";

export default {
    components: {
        ContractedWorksTask,
        UiDropdownDivider,
        UiDropdown,
        UiDropdownItem,
        draggable,
    },
    props: {
        search:'',
        latest: Object,
        contractedWorks: Object,
        contract: Object,
        section: Object,
        showItemProgress: Boolean,
        showOmitted: Boolean,
        currentViewing: false,
        currentlyBuilding: false,
        latestProgressReport: Object,
        operations: [],
    },
    data() {
        return {
            name: this.section.name,
            proposedStatus: this.section.proposedStatus,
            status: this.section.status,
            original: this.latest ? this.latest.scopeOfWorks.find((i) => i.id === this.section.id) : null,
            totalValueKey: 0,
        }
    },
    computed: {},
    methods: {
        operationsFromExists(type) {
            if (this.operations) {
                let op = this.operations.find((i) => (i.subject.id === this.section.id) && (i.subject.type === 'Section') && (i.type === 'Substitution'));
                if (op) {
                    let prop = op.value[type]
                    return (typeof prop !== 'undefined' && prop !== null)
                }
            }
            return false;
        },
        operationsFrom(type) {
            if (this.operations) {
                let op = this.operations.find((i) => (i.subject.id === this.section.id) && (i.subject.type === 'Section') && (i.type === 'Substitution'));
                return op.value[type].from ? op.value[type].from : '<blank>'
            }
            return '<blank>';
        },
        getBGClass() {
            if (this.proposedStatus === 'OMITTED') {
                return ' bg-red-50';
            }
            if (this.proposedStatus === 'ADDED') {
                return ' bg-green-50';
            }
            if (this.proposedStatus === 'SUBSTITUTED') {
                return ' bg-orange-50'
            }
            return ' bg-white';
        }
    },
}
</script>
